import 'immer';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import type {
  Invoice,
  InvoiceSearchOutput,
  InvoiceSearchInput,
} from '@repo/api-contract';
import ApiClient from '../../util/api-client';
type SearchBy = InvoiceSearchInput['searchBy'];

export interface InvoiceBrowseState {
  searchInput: string;
  results?: InvoiceSearchOutput;
  searchBy: SearchBy;
  loading: boolean;
  activeSelection?: Invoice;
}

// Initialize state
const initialState: InvoiceBrowseState = {
  searchInput: '',
  results: undefined,
  searchBy: 'companyName',
  loading: false,
  activeSelection: undefined,
};

export const invoiceBrowseSlice = createSlice({
  name: 'invoiceBrowse',
  initialState,
  reducers: {
    setSearchInput: (state, action: PayloadAction<string>) => ({
      ...state,
      searchInput: action.payload,
    }),
    setSearchBy: (state, action: PayloadAction<SearchBy>) => ({
      ...state,
      searchBy: action.payload,
    }),
    setResults: (
      state,
      action: PayloadAction<InvoiceSearchOutput | undefined>,
    ) => ({
      ...state,
      results: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setActiveSelection: (state, action: PayloadAction<Invoice>) => ({
      ...state,
      activeSelection: action.payload,
    }),
  },
});

export const {
  setSearchInput,
  setSearchBy,
  setResults,
  setLoading,
  setActiveSelection,
} = invoiceBrowseSlice.actions;
export default invoiceBrowseSlice.reducer;

// Thunks
export const searchInvoices =
  (searchInput: InvoiceSearchInput) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(setLoading(true));
      const results = await ApiClient.searchInvoices.query(searchInput);
      dispatch(setResults(results));
    } catch (error: unknown) {
      dispatch(setResults(undefined));
    } finally {
      dispatch(setLoading(false));
    }
  };
